import React from 'react';

import { Wrapper } from './atoms/Wrapper';
import { RightCol } from './atoms/RightCol';
import { PullLeft } from './atoms/PullLeft';
import { PageTitle } from '../PageTitle';
import { PageDescription } from '../PageDescription';

export interface PageSectionIntroProps {
    title: string;
    description: string;
}
export const PageSectionIntro: React.FC<PageSectionIntroProps> = ({ title, description }) => (
    <Wrapper>
        <RightCol>
            <PullLeft>
                <div>
                    <PageTitle>{title}</PageTitle>
                    <PageDescription>{description}</PageDescription>
                </div>
            </PullLeft>
        </RightCol>
    </Wrapper>
);
